import ACTIONS from "../Design_Asset_Actions.json";
const initialComponentData = {};
const updateComponents = (state, components) =>{
 
  return {
    ...state,
    ...components
  }
}
const ComponentDataReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.UPDATE_COMPONENT_DATA:
      return updateComponents(state, action.payload );
    case ACTIONS.RESET_COMPONENT_DATA:
      return initialComponentData;
    default:
      return state;
  }
};

export { initialComponentData, ComponentDataReducer };
